import styled from 'styled-components';
import {color} from 'styled-system';
import {WindowSizePXEnum} from "../interface/Basic/window";
import {InputProps} from "./ui/InputSearch";


export const H1 = styled.h1`
  font-weight: 700;
  font-size: 38px;
  line-height: 44px;
  letter-spacing: -0.3px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    font-size: 32px;
    line-height: 36px;
  }
`;
export const H1Top = styled(H1)`
  margin-top: 8px;
`;

export const H2 = styled.h2`
  margin: 0;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const H3 = styled.h3`
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
`
export const Name = styled(H2)`
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin: 12px 0 0 0;
  }
`;

export const Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  margin: 0 0 8px 20px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin: 10px 0 8px;
  }
`;
export const TitleСontact = styled.h2`
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin: 0;
`;


export const LightGray = styled.p`
  color: #898F97;
`;

export const Body1 = styled.div`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.3px;
  ${color};
`;


export const ConfirmedText = styled(Body1)`
  color: ${({theme}) => theme.color.septenary};
`
export const Body1Pointer = styled(Body1)`
  cursor: pointer;
  user-select: none;
`
export const Body1PointerLink = styled(Body1Pointer)`
  ${color};
  color: ${({theme}) => theme.color.indicator};

  :hover {
    filter: opacity(.8);
  }

  :active {
    filter: opacity(.7);
  }
`

export const Body1PointerLinkXl = styled(Body1Pointer)`
  ${color};
  color: ${({theme}) => theme.color.indicator};

  :hover {
    filter: opacity(.8);
  }

  :active {
    filter: opacity(.7);
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display:none;
  }
`
export const Body1PointerLinkXs = styled(Body1Pointer)`
  display: none;
  ${color};
  color: ${({theme}) => theme.color.indicator};

  :hover {
    filter: opacity(.8);
  }

  :active {
    filter: opacity(.7);
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: block;
  }
`
export const Body1Red = styled(Body1)`
  color: red;
`
export const Body1Flex = styled(Body1)`
  display: flex;
  gap: 5px;
`
export const Body2 = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.2px;
  ${color};
`;
export const Body2Pointer = styled(Body2)`
  cursor: pointer;
`;

export const Secondary = styled(Body1)`
  color: ${({theme}) => theme.color.secondary};
`;

export const Caption1 = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1px;
  ${color};
`;

export const FormBottomCaptionContent = styled.div`
  margin-top: -8px
`
export const Caption2 = styled.div<InputProps>`
  visibility: ${props => props.error ? 'hidden' : 'unset'} !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  ${color};
`;

export const RegFormCaption = styled(Caption2)`
  visibility: ${props => props.error ? 'hidden' : 'unset'} !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: start;
   width: 100%; 
   margin: 20px 0 8px;
  ${color};
`;

export const Caption2PointerLink = styled(Caption2)`
  cursor: pointer;
  color: ${({theme}) => theme.color.indicator};

  :hover {
    filter: opacity(.8);
  }

  :active {
    filter: opacity(.7);
  }
`
export const Caption4 = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  ${color};
`
export const ModalInfoDiscription = styled(Body1)`
  min-width: 185px;
`
export const SubheadLight = styled.div`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  ${color};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SubheadGray = styled(SubheadLight)`
  color: #AFB9C5;

`;
export const Caption1Uppercase = styled(Caption1)`
  text-transform: uppercase;
`;
export const Subhead1 = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  ${color};
`;

export const Subhead2 = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 22px;
  ${color};
`;

export const Subhead3 = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 22px;
  ${color};
`;

export const SubheadRegular = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  text-overflow: ellipsis;
  ${color};
`;

export const SubheadMedium = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.2px;
  ${color};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RegisterNotificationBody = styled(Body1)`
  margin-left: 14.5px !important;
  text-align: left;
`;

export const VerifyButtonsContent = styled.div`
  margin-top: 16px;
  gap: 10px;
  display: flex;
  @media(max-width: ${WindowSizePXEnum.xs}){
    flex-direction: column;
  }
`

export const AvatarMenuText = styled(Body1)`
  :hover {
    cursor: pointer;
  }
`

export const SecurityTitle = styled(H3)`
  margin: 0;
  @media(max-width: ${WindowSizePXEnum.xs}){
    margin-top: 40px;
  }
`

export const SecurityInfoDescription = styled(ModalInfoDiscription)`
  width: 271px;
`

export const EditPhoneTextContent = styled(Body1)`
  width: 302px;
  height: 40px;
  margin-bottom: 24px;

`

export const PasswordFormBottomContent = styled.div`
  margin-top: -24px;
  text-align: left;
  margin-bottom: 16px;
`

export const FAQTitle = styled(H3)`
  margin: 0 0 2px 0;
`

export const FAQQuestion = styled(Body1)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  align-content: flex-start;
`

export const FAQSolutionText = styled(Body1)`
  margin-left: 4px;
  color: ${({theme}) => theme.color.secondary};
  line-height: 20px;
  letter-spacing: -0.3px;
`

export const ConfirmPhoneInfo = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`

export const SecurityEmailTitle = styled(Title)`
  width: 180px;
  margin-bottom: 28px;
`

export const SecurityPasswordTitle = styled(Title)`
  margin-bottom: 28px
`

export const SecurityPasswordBottomContent = styled(PasswordFormBottomContent)`
  margin-top: -8px;
  margin-bottom: 24px;
`

export const FormTitle = styled(H2)`
  text-align: center;
  width: 243px;
  font-size: 22px;
  line-height: 28px;
  @media(max-width: ${WindowSizePXEnum.xs}){
    width: 300px;
  }
`

export const PasswordRules = styled(Caption2)`
  text-align: left;
  margin-top: 8px;
  margin-bottom: 12px;
`
export const RecoveryEmailInfo = styled(Body1)`
  text-align: center;
  width: 240px;
  margin-top: 12px;
`

export const MailLink = styled.a`
  text-decoration: none;
  :link{
    ${color};
  }
  ${color};
`

export const RecoveryPasswordInfo = styled(Body1)`
  text-align: center;
  width: 240px;
  margin-bottom: 24px;
`
export const LeftText= styled(Body1)`
  text-align: left;
`

export const SecurityText = styled(Body1)`
  text-align: left;
  min-width: 185px;
  max-width: 180px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    max-width: unset;
    width: 159px;
    min-width: unset;
    max-width: 140px;
  }
`
export const ChangeIdentityLink = styled.a`
  text-decoration: none;
  :hover{
    cursor: pointer;
  }
  :link{
    ${color};
  }
  ${color};
`

export const ModalsTitle = styled(H2)`
  font-size: 28px;
  @media(max-width: ${WindowSizePXEnum.xs}){
    padding-left:20px;
  }
`
export const EnterPhoneBottom = styled(Caption2)`
  text-align: center;
  display: inline;
  padding: 16px 32px;
`

export const SystemsTitle = styled(H3)`
  margin: 0;
  padding:  24px 24px 0px 24px;
  @media(max-width: ${WindowSizePXEnum.xs}){
    padding-left: 20px;
  }
`